/**
 * Created by Gavin on 2018/3/16.
 */
import {all} from 'redux-saga/effects';
import {authenticationSagas} from "reducers/authenticationNew";
export default function* rootSaga() {
  try {
    yield all(
      [
        ...authenticationSagas
      ]
    )
  }
  catch (e){
    console.log(e);
  }
}
